import { BrowserModule } from "@angular/platform-browser";
import { Ng2CompleterModule } from "ng2-completer";

import { AppComponent } from "./app.component";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RegisterComponent } from "app/register/register.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { TooltipDirective } from "app/tooltip/tooltips.directive";
import { NgModule } from "@angular/core";
import { ServiceModule } from "app/services/service.module";
import { RegisterRouterModule } from "app/router/register.router.module";
import { ConfirmdialogComponent } from "./register/confirmdialog/confirmdialog.component";
import { CookieModule } from "ngx-cookie";
import { RetrieveComponent } from "app/register/retrievedialog/retrieve.component";

import {ABCNDirective} from "app/tooltip/abn.directive";
import { ProgressComponent } from './tooltip/progress/progress.component';
import { ResleerphoneDirective } from './tooltip/resleerphone.directive';
import { TermsComponent } from './terms/terms.component';
import { TermsDialogComponent } from './register/terms-dialog/terms-dialog.component';
import { LandingComponent } from './landing/landing.component';

//pdf solution
// import { PdfViewerComponent } from 'ng2-pdf-viewer';

@NgModule({
  declarations: [
    AppComponent,
    RegisterComponent,
    TooltipDirective,
    ConfirmdialogComponent,
    RetrieveComponent,
    ABCNDirective,
    ProgressComponent,
    ResleerphoneDirective,
    TermsComponent,
    TermsDialogComponent,
    LandingComponent,
    // PdfViewerComponent
  ],
  imports: [
    CookieModule.forRoot(),
    BrowserAnimationsModule,
    BrowserModule,

    ReactiveFormsModule,
    HttpModule,
    FormsModule,
    Ng2CompleterModule,
    ServiceModule,
    RegisterRouterModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts